import { render, staticRenderFns } from "./CountryRankings.vue?vue&type=template&id=ffa1d50e&scoped=true&"
import script from "./CountryRankings.vue?vue&type=script&lang=js&"
export * from "./CountryRankings.vue?vue&type=script&lang=js&"
import style0 from "./CountryRankings.vue?vue&type=style&index=0&id=ffa1d50e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ffa1d50e",
  null
  
)

export default component.exports